/** Route segments whose next segment is a secret, e.g. /fr/reset-password/<token>. */
const SECRET_AFTER = new Set(['reset-password']);

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LONG_HEX = /^[0-9a-f]{32,}$/i;

/**
 * The path reported to analytics. Tokens and identifiers are replaced and the
 * query string and hash are dropped, since they can carry OAuth or reset
 * tokens.
 */
export function sanitizeAnalyticsPath(pathname: string): string {
  const path = pathname.split(/[?#]/, 1)[0] || '/';
  const segments = path.split('/');

  const cleaned = segments.map((segment, index) => {
    if (index > 0 && SECRET_AFTER.has(segments[index - 1].toLowerCase()) && segment) {
      return ':token';
    }
    if (UUID.test(segment) || LONG_HEX.test(segment)) return ':id';
    return segment;
  });

  return cleaned.join('/') || '/';
}
